import baseScmService from 'services/baseScmService';

const sbatGroupSuperBatchProjectService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    bulkUpdateSbatGroupSuperBatchProjects: build.mutation({
      query: ({ sbatGroup, superBatchProject }) => ({
        method: 'PUT',
        url: `/sbat-groups/${sbatGroup.id}/super-batch-projects/bulk-update`,
        body: {
          academy_project_id: superBatchProject.academyProjectId,
          start_time: superBatchProject.startTime,
          end_time: superBatchProject.endTime,
        },
      }),
      invalidatesTags: (result, error, { sbatGroup, superBatchProject }) =>
        error
          ? []
          : [
              { type: 'SbatGroup', id: sbatGroup.id },
              { type: 'SuperBatchProject', id: superBatchProject.id },
            ],
    }),
  }),
  overrideExisting: false,
});

export const { useBulkUpdateSbatGroupSuperBatchProjectsMutation } =
  sbatGroupSuperBatchProjectService;

export default sbatGroupSuperBatchProjectService;
